import { DISPATCH_EVENT_KEYS, SIGNALING_COMMANDS } from 'src/consumer/constants'
import { addWindowSignalingEventListener } from 'src/live/signaling/windowSignalingEvents'

// Inbound / receive-call plumbing for support agents.
//
// The app already carries support signals on window (DISPATCH_EVENT_KEYS.supportSignalingEvent,
// used for WhatsApp thread updates). Inbound calls ride the same bus under a new command. The
// subscription is created ONLY while the agent has toggled "available for calls", so there is no
// always-on socket. The backend that emits SUPPORT_INBOUND_CALL is the remaining net-new piece —
// use simulateSupportInboundCall(...) to exercise the accept/reject UI until then.

export function subscribeSupportInboundCalls({ onIncoming, onCancelled } = {}) {
  return addWindowSignalingEventListener({
    dispatchEventKey: DISPATCH_EVENT_KEYS.supportSignalingEvent,
    handler: (event) => {
      const detail = event?.detail
      if (!detail?.command) {
        return
      }
      if (detail.command === SIGNALING_COMMANDS.SUPPORT_INBOUND_CALL) {
        onIncoming?.(normalizeInboundPayload(detail.payload))
      } else if (detail.command === SIGNALING_COMMANDS.SUPPORT_INBOUND_CALL_CANCELLED) {
        onCancelled?.(normalizeInboundPayload(detail.payload))
      }
    },
  })
}

function normalizeInboundPayload(payload = {}) {
  return {
    callId: payload?.callId || payload?.interactionId || '',
    callerName: payload?.callerName || payload?.targetDisplayName || payload?.name || 'Incoming caller',
    callerRole: payload?.callerRole || payload?.targetRole || 'patient',
    maskedNumber: payload?.maskedNumber || payload?.maskedDestination || payload?.targetPhoneNumber || '',
    rawPhone: payload?.rawPhone || payload?.phoneNumber || '',
    patientId: payload?.patientId || '',
    practitionerId: payload?.practitionerId || '',
    bookedEventId: payload?.bookedEventId || '',
    clinicBrandId: payload?.clinicBrandId || '',
    clinicId: payload?.clinicId || '',
    clinicBrandName: payload?.clinicBrandName || '',
    eventType: payload?.eventType || '',
    receivedAt: payload?.receivedAt || new Date().toISOString(),
  }
}

// Dev/testing helper: fire a synthetic inbound-call signal on the same bus a real backend would
// use. Available on window as __simulateSupportInboundCall for quick manual testing in preview.
export function simulateSupportInboundCall(payload = {}) {
  if (typeof window === 'undefined') {
    return
  }
  window.dispatchEvent(
    new window.CustomEvent(DISPATCH_EVENT_KEYS.supportSignalingEvent, {
      detail: {
        command: SIGNALING_COMMANDS.SUPPORT_INBOUND_CALL,
        payload: {
          callId: `sim-${Date.now()}`,
          callerName: 'Simulated caller',
          callerRole: 'patient',
          maskedNumber: '+91••••••1234',
          ...payload,
        },
      },
    }),
  )
}

if (typeof window !== 'undefined') {
  window.__simulateSupportInboundCall = simulateSupportInboundCall
}
